import { request } from './Request';
import { routes } from '../constants/constant.route';

const { GETCITY, GETSTATE, GET_SUBSDIRES,
  ADD_SUBSDIRES, DELETE_SUBSDIRES, EDIT_SUBSDIRES } = routes.SUBS_DIARIES;
const API_URL = process.env.REACT_APP_API_URL;

export default class AddEditSubsidiariesService {


  /**
   * @name getState
   * @description Get State
   * @param {}
   * @method GET
   * @returns promise
   */
  static getState() {
    return request('GET', `${API_URL}${GETSTATE}`, null, null, null);
  }

  /**
   * @name getCity
   * @description Get City based on State
   * @param {statId: String}
   * @method GET
   * @returns promise
   */
  static getCity(statId) {
    return request('GET', `${API_URL}${GETCITY}?state_id=${statId}`, null, null, null);
  }

  /**
    * @name getSubsidiaries
    * @description Get Subsidiaries 
    * @param {}
    * @method GET
    * @returns promise
    */
  static getSubsidiaries(id = null) {
    if (id) {
      return request('GET', `${API_URL}${routes.NEW_FLEET.GET_SUBSDIRES}?id=${id}`, null, null, null);
    } else {
      return request('GET', `${API_URL}${GET_SUBSDIRES}`, null, null, null);
    }
  }

  /**
    * @name getSubsidiaries
    * @description Get Subsidiaries for profile
    * @param {}
    * @method GET
    * @returns promise
    */
  static getSubsidiariesProfile(id = null) {
    let qp = '';
    if (id) {
      qp = `?id=${id}`;
    }
    return request('GET', `${API_URL}${GET_SUBSDIRES}${qp}`, null, null, null);

  }

  /**
  * @name addSubsidiaries
  * @description Add Subsidiaries 
  * @param {data: Object}
  * @method POST
  * @returns promise
  */
  static addEditSubsidiaries(data) {
    if (data.from && data.from === 'enroll-new-fleet') {
      return request('POST', `${API_URL}${data.uuid ? routes.NEW_FLEET.EDIT_SUBSDIRES : routes.NEW_FLEET.ADD_SUBSDIRES}`, null, data, null);
    } else {
      return request('POST', `${API_URL}${data.uuid ? EDIT_SUBSDIRES : ADD_SUBSDIRES}`, null, data, null);
    }
  }

  static addEditSubsidiariesProfile(data) {
    let qp = '';
    if (data.fleet_id) {
      qp = `?id=${data.fleet_id}`;
    }
    return request('POST', `${API_URL}${data.uuid ? EDIT_SUBSDIRES : ADD_SUBSDIRES}${qp}`, null, data, null);
  }


  /**
  * @name deleteSubsidiaries
  * @description Add Subsidiaries 
  * @param {data: Object}
  * @method POST
  * @returns promise
  */
  static deleteSubsidiaries(id, temp_id = null) {
    if (temp_id) {
      return request('POST', `${API_URL}${routes.NEW_FLEET.DELETE_SUBSDIRES}`, null, id, null);
    } else {
      return request('POST', `${API_URL}${DELETE_SUBSDIRES}`, null, id, null);
    }
  }
}